import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { useToast } from '../hooks/use-toast';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Login = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, formData);
      const { access_token, user } = response.data;

      // Store token and user info
      localStorage.setItem('token', access_token);
      localStorage.setItem('user', JSON.stringify(user));

      toast({
        title: "Login Successful!",
        description: `Welcome back, ${user.full_name}`,
      });

      // Redirect based on role
      if (user.role === 'admin') {
        navigate('/admin/dashboard');
      } else {
        navigate('/member/dashboard');
      }
    } catch (error) {
      toast({
        title: "Login Failed",
        description: error.response?.data?.detail || "Invalid credentials",
        variant: "destructive"
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4">
      <Card className="w-full max-w-md shadow-xl">
        <CardHeader className="text-center">
          <img 
            src="https://customer-assets.emergentagent.com/job_20414c3a-9623-4d12-8f24-8780a5aa64c8/artifacts/y936iv32_%3D2_transparent_logo.png" 
            alt="Equaltoo" 
            className="h-20 w-auto mx-auto mb-4"
          />
          <CardTitle className="text-3xl text-gray-900">Member Login</CardTitle>
          <CardDescription className="text-lg">Access your Equaltoo member portal</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="email">Email Address</Label>
              <Input
                id="email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="your.email@example.com"
                className="mt-2"
              />
            </div>

            <div>
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                name="password"
                type="password"
                value={formData.password}
                onChange={handleChange}
                required
                placeholder="Enter your password"
                className="mt-2"
              />
            </div>

            <Button 
              type="submit" 
              className="w-full bg-[#e74c3c] hover:bg-[#c0392b]" 
              size="lg"
              disabled={isLoading}
            >
              {isLoading ? 'Logging in...' : 'Login'}
            </Button>

            <div className="text-center text-sm text-gray-600">
              <p>
                <Link to="/forgot-password" className="text-[#e74c3c] hover:underline" data-testid="forgot-password-link">
                  Forgot your password?
                </Link>
              </p>
              <p className="mt-2">Don't have an account? <a href="/membership" className="text-[#e74c3c] hover:underline">Become a Member</a></p>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default Login;
